import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../core/auth.service';
import {catchError, concatMap, finalize} from 'rxjs/operators';
import {of} from 'rxjs';
import {MatCard, MatCardContent, MatCardFooter, MatCardImage} from '@angular/material/card';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'rtapp-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    imports: [MatCard, MatCardImage, MatCardContent, MatTabGroup, MatTab, MatButton, MatCardFooter]
})
export class LoginPageComponent implements OnInit {

    public version: string = environment.VERSION;
    public show = false;
    ssoUrl = `${environment.ssoUrl}?r=${window.location.href}/`;

    constructor(private auth: AuthService,
                private route: ActivatedRoute,
                private router: Router) {
        this.auth.setCompound(this.compound);
    }

    get compound() {
        if (window.location.hostname === 'localhost') {
            if (this.route.snapshot.url[0].path === 'login-mos') {
                return 'MOS';
            }
            if (this.route.snapshot.url[0].path === 'login-klnt') {
                return 'KLNT';
            }
        }
        return 'BOTH';
    }

    ngOnInit() {
        const token = this.route.snapshot.paramMap.get('token');
        if (token) {

            this.auth.ssoSignIn(token)
                .pipe(
                    concatMap(() => of('apply/home')),
                    catchError(() => of(this.auth.getLoginPath)),
                    concatMap((path: string) => this.router.navigateByUrl(path)),
                    finalize(() => this.show = true),
                ).subscribe();
        } else {
            this.show = true;
        }
    }

    getSsoUrl(): string {
        return this.ssoUrl;
    }

}
